import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=21b3a5fc&scoped=true&"
import script from "./BasicForm.vue?vue&type=script&lang=js&"
export * from "./BasicForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicForm.vue?vue&type=style&index=0&id=21b3a5fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3a5fc",
  null
  
)

export default component.exports